import { render, staticRenderFns } from "./ProjTab.vue?vue&type=template&id=c200299c"
import script from "./ProjTab.vue?vue&type=script&lang=js"
export * from "./ProjTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports